export const MARKER_ID = 'arrow-marker'
export const EDGE_COLOR = '#000'
export const DEFAULT_EDGE_STROKE_WIDTH = 3
export const DIAGRAM_BG_COLOR = '#f7f7f7'
